import { environment } from "../environments/environment";

export class AppSettings {
  public static photoUrl = environment.serverUrl + 'download/';
  public static ServerUrl = environment.serverUrl;

}